import React, { useState } from "react";
import { useParams } from "react-router-dom";
import TrackingService from "../../services/trackingService";
import { Map } from "./map";
import { Marker } from "./marker";

export const Tracker = (props) => {

    const service = TrackingService();
    
    const { token } = useParams();

    const [zoom, setZoom] = React.useState(16); // initial zoom
    const [center, setCenter] = React.useState({
      lat: 0,
      lng: 0,
    });

    const [markerPosition, setMarkerPosition] = React.useState({
        lat: 0,
        lng: 0,
    });


    const updateVehiclePosition = (isFirstLoad) => {
        service.getVehicle(token).then(vehicle => {
            console.log(vehicle);
            if(isFirstLoad) {
                setCenter({
                    lat: vehicle.gps.latitude,
                    lng: vehicle.gps.longitude
                });
            }
            setMarkerPosition({
                lat: vehicle.gps.latitude,
                lng: vehicle.gps.longitude
            });
        });
    }

    useState(() => {
        updateVehiclePosition(true);
        setInterval(updateVehiclePosition, 15000);
    }, [token]);

    return (
        <Map
        center={center}
        zoom={zoom}
        style={{ flexGrow: "1", minHeight: "100%" }}>
            <Marker position={markerPosition} />
        </Map>
    );
};
